import { parametric, subscription, pathSubscription } from 'nike-re-framejs';

export const isBetradarWidgetLoaded$ = parametric(widgetType =>
    subscription(db => db.getIn(['infocentrum', 'detail', 'widgetLoaded', widgetType]))
);

export const isEventCentreBlocked$ = subscription(db =>
    db.getIn(['infocentrum', 'detail', 'eventCentreAllowed', 'error'])
);

export const isLiveEvent$$ = pathSubscription(['infocentrum', 'detail', 'match', 'isLive']);

export const getTabsForTournament$ = parametric(tabTemplateId => {
    return pathSubscription(['infocentrum', 'templates', tabTemplateId?.toString(), 'templates']);
});

export const isInfocentreTemplatesLoaded$ = subscription(db => !!db.getIn(['infocentrum', 'templates']));
